import store from '@/model/global/store'

export function formatPrice (price) {
  if (isNaN(parseFloat(price)) || (price === Infinity || price === -Infinity)) {
    return ' - '
  }
  if (price.includes && price.includes(',')) {
    price = price.replace('.', '').replace(',', '.')
  }

  // Parse the price and handle negative zero
  const parsedPrice = parseFloat(price)
  const isNegativeZero = parseFloat(parsedPrice.toFixed(2)) === 0 && 1 / parsedPrice === -Infinity
  const isNegative = parsedPrice < 0 || isNegativeZero
  const absPrice = Math.abs(parsedPrice)

  if (store.state.currencySymbols === '$') {
    // For $ currency: Use US locale (commas as thousand separators, dots as decimal)
    const formattedNumber = absPrice.toLocaleString('en-US', {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2
    })
    return (isNegative ? '-' : '') + store.state.currencySymbols + ' ' + formattedNumber
  } else {
    // For other currencies: Use European locale (dots as thousand separators, commas as decimal)
    const formattedNumber = absPrice.toLocaleString('de-DE', {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2
    })
    return (isNegative ? '-' : '') + formattedNumber + ' ' + store.state.currencySymbols
  }
}
